import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioInputGroup, RadioInput } from '@instructure/ui-radio-input';
import t from '@instructure/quiz-i18n/format-message';
import Setting from '../Setting';
var calcTypes = [{
  value: 'basic',
  label: t('Basic')
}, {
  value: 'scientific',
  label: t('Scientific')
}];
export var Calculator = /*#__PURE__*/function (_Component) {
  function Calculator() {
    var _this2;
    _classCallCheck(this, Calculator);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, Calculator, [].concat(args));
    _defineProperty(_this2, "defaultType", 'basic');
    // =============
    //    ACTIONS
    // =============
    _defineProperty(_this2, "toggleAllowCalculator", function (event, changeCompleteCb) {
      if (_this2.calculatorIsAllowed()) _this2.defaultType = _this2.props.calculatorType;
      var _this2$props = _this2.props,
        setCalculatorType = _this2$props.setCalculatorType,
        activeQuizId = _this2$props.activeQuizId;
      var calculatorType = event.target.checked ? _this2.defaultType : 'none';
      setCalculatorType(activeQuizId, calculatorType, changeCompleteCb);
    });
    _defineProperty(_this2, "setAllowedCalculatorType", function (changeCompleteCb) {
      return function (e, value) {
        var _this2$props2 = _this2.props,
          setCalculatorType = _this2$props2.setCalculatorType,
          activeQuizId = _this2$props2.activeQuizId;
        setCalculatorType(activeQuizId, value, changeCompleteCb);
      };
    });
    return _this2;
  }
  _inherits(Calculator, _Component);
  return _createClass(Calculator, [{
    key: "calculatorIsAllowed",
    value: function calculatorIsAllowed() {
      return this.props.calculatorType !== 'none';
    }
  }, {
    key: "render",
    value:
    // =============
    //   RENDERING
    // =============

    function render() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement(Setting, {
        isChecked: this.calculatorIsAllowed(),
        showMore: this.calculatorIsAllowed(),
        label: t('Allow Calculator'),
        onChange: this.toggleAllowCalculator
      }, function (changeCompleteCb) {
        return /*#__PURE__*/React.createElement(RadioInputGroup, {
          name: "calculatorOptions",
          description: t('Calculator Type'),
          value: _this3.props.calculatorType,
          onChange: _this3.setAllowedCalculatorType(changeCompleteCb)
        }, calcTypes.map(function (calcType) {
          return /*#__PURE__*/React.createElement(RadioInput, {
            key: calcType.value,
            value: calcType.value,
            label: calcType.label,
            "data-automation": "sdk-calculator-type-".concat(calcType.value)
          });
        }));
      });
    }
  }]);
}(Component);
_defineProperty(Calculator, "propTypes", {
  activeQuizId: PropTypes.string.isRequired,
  calculatorType: PropTypes.string,
  setCalculatorType: PropTypes.func.isRequired
});
_defineProperty(Calculator, "defaultProps", {
  calculatorType: 'none'
});
export default Calculator;